export default class LessonSettingService {
  constructor(http) {
    this.http = http;
  }

  async findAllLessonSetting(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/lessonsetting/readall?${queryParams}`, {
      method: "GET",
    });
  }

  async createLessonSetting(data) {
    return this.http.fetch(`/api/lessonsetting/create`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  async updateLessonSetting(data) {
    return this.http.fetch(`/api/lessonsetting/update`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  async deleteLessonSetting(data) {
    return this.http.fetch(`/api/lessonsetting/delete`, {
      method: "DELETE",
      body: JSON.stringify(data),
    });
  }
}
